const reviews = [
  {
    name: 'Ryan S',
    business: 'Pioneer Plumbing',
    text: "I wasn't convinced we needed a new website. Most of our jobs came from word of mouth. But after they rebuilt it, we started getting steady calls from people who found us on Google. Didn't expect that.",
    rating: 5
  },
  {
    name: 'Mark V',
    business: 'Service Electric Inc.',
    text: "I figured a website was just something you're supposed to have. Didn't think it would actually bring in work. A few weeks after launching, we started getting estimate requests through it. It's pulling its weight.",
    rating: 5
  },
  {
    name: 'Spencer S',
    business: 'GreenScape',
    text: "I honestly thought this would just make us look more professional. I didn't expect it to generate actual leads. We've already booked a couple decent-sized jobs that came straight from the site. That surprised me.",
    rating: 5
  }
];

export default function Reviews() {
  return (
    <section className="py-24 px-6 bg-[#0A0A0A] relative">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black mb-4">
            What Service Business Owners <span className="text-[#3B82F6]">Are Saying</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Real results from real service businesses who took the leap
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-[#151515] border border-[#3B82F6]/20 rounded-2xl p-8 hover:border-[#3B82F6]/40 transition-all"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(review.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-[#3B82F6] text-lg"></i>
                  </div>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-300 text-base leading-relaxed mb-6">
                "{review.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-6 border-t border-[#3B82F6]/20">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/30">
                  <i className="ri-user-line text-[#3B82F6] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-white">{review.name}</p>
                  <p className="text-sm text-gray-400">{review.business}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
